// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"172":"4fe938e3","235":"be4d5d99","453":"abedfe83","799":"2d31f007","805":"ba633f2e","806":"264dfb91"}[chunkId] + ".chunk.js";
};